import CityMap from './components/CityMap.vue';
import InitLazyComponent from 'Main/modules/InitLazyComponent';

const cityMap = document.getElementById('city-map-container');
const initLazyComponent = new InitLazyComponent({
  selectors: cityMap,
  components: { CityMap },
  template: '<CityMap />',
});

initLazyComponent.init();
